import(/* webpackMode: "eager" */ "/codebuild/output/src1948180265/src/client/src/app/error.tsx");
